module.exports = __webpack_public_path__ + "static/about-liz-img-update-1-dc1bacf64af52d32e5d7e142eda10acc.png";